import { Checkbox } from "antd";
// import { String } from "aws-sdk/clients/batch";
import React from "react";

interface CheckboxValue {
  value: boolean;
  name: string;
}

interface Checkboxes {
  customWelding: CheckboxValue;
  newFence: CheckboxValue;
  repairFence: CheckboxValue;
  woodFence: CheckboxValue;
  metalFence: CheckboxValue;
  fenceGate: CheckboxValue;
  drivewayGate: CheckboxValue;
  fenceStaining: CheckboxValue;
}

interface QuoteFormCheckboxesProps {
  checkboxes: Checkboxes;
  setCheckBoxes: (value: Checkboxes) => void;
}

const getKeyValue = (keyName: string) => {
  switch (keyName) {
    case "customWelding":
      return "customWelding";
    case "newFence":
      return "newFence";
    case "repairFence":
      return "repairFence";
    case "woodFence":
      return "woodFence";
    case "metalFence":
      return "metalFence";
    case "fenceGate":
      return "fenceGate";
    case "drivewayGate":
      return "drivewayGate";
    case "fenceStaining":
      return "fenceStaining";
    default:
      return "fenceStaining";
  }
};

const QuoteFormCheckboxes = (props: QuoteFormCheckboxesProps) => {
  const { checkboxes, setCheckBoxes } = props;

  const changeHandler = (keyname: string, inputValue: boolean) => {
    const keyvalue = getKeyValue(keyname);
    setCheckBoxes({
      ...checkboxes,
      [keyvalue]: {
        ...checkboxes[keyvalue],
        value: inputValue,
      },
    });
    return;
  };

  return (
    <div className="grid" style={{alignItems: 'flex-start'}}>
      {Object.keys(checkboxes).map((keyName: string) => {
        const keyvalue = getKeyValue(keyName);
        return <div key={keyvalue} className="p-2 checkbox-container">
    

            <Checkbox  key={keyName} checked={checkboxes[keyvalue].value} onChange={(e) => changeHandler(keyvalue, e.target.checked)}>
            {checkboxes[keyvalue].name}
        </Checkbox>
     
        </div>;
      })}
    </div>
  );
};
export default QuoteFormCheckboxes;
